import React from 'react';
import MediaUploadPopup from './MediaUploadPopup';
import UploadIcon from '../../shared/MediaUploadIcon';

function MediaUploadButton({
	text,
	icon,
	className,
	name,
	handleMediaSubmission,
	setMediaFileName,
	orgID,
	handleClearingMedia,
	openCloudinaryWidget,
	setArticleData,
}) {
	const [show, setShow] = React.useState(false);

	function handleClick() {
		setShow(!show);
	}
	return (
		<div className="media-upload-button-background-div">
			<div
				className={`media-upload-button ${className}`}
				onClick={handleClick}
			>
				<p className="media-upload-button-text">{text}</p>
				{icon && <UploadIcon />}
			</div>
			{show && (
				<MediaUploadPopup
					handleClose={handleClick}
					handleMediaSubmission={handleMediaSubmission}
					name={name}
					setMediaFileName={setMediaFileName}
					orgID={orgID}
					handleClearingMedia={handleClearingMedia}
					openCloudinaryWidget={openCloudinaryWidget}
					setArticleData={setArticleData}
				/>
			)}
		</div>
	);
}

export default MediaUploadButton;
